import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";
import handleValidation from "../../Validation";
import { Link } from "react-router-dom";
import FontAwesome from "react-fontawesome";
import "./style.css";

class QuestionForm extends Component {
  state = {
    first_name: "",
    email: "",
    phoneNumber: "",
    errors: {},
    errorsdiv: false
  };

  submitDetails = event => {
    debugger;

    let formData = {
      first_name: this.refs.first_name.value,
      email: this.refs.email.value
    };
    let errors = handleValidation(formData);
    this.setState({ errors: errors });
    if (errors["valid"] == true) {
      document.getElementById("aboutUs").action =
        "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8";
      document.getElementById("aboutUs").method = "POST";
    } else {
      this.setState({ errorsdiv: true });
      event.preventDefault();
    }
  };

  render() {
    return (
      <div className="question-form-section section-padding">
        <Container>
          <Row className='justify-content-center'>
            <Col sm={{ size: 12 }} md={{size: 8}}>
              <Row className="have-questions-form">
                <Col sm={{ size: 12 }}>
                  <h1 className="mt-5 mb-3 text-center">{this.props.title}</h1>
                  <hr className="heading-underline mb-5" />
                </Col>
              </Row>
              <Row>
                <Col sm={{ size: 5 }}>
                  <h3>{this.props.textTitle}</h3>
                  <p className="question-form-text">{this.props.text}</p>
                  <p className="question-form-text">
                    <FontAwesome
                      className="map-marker-alt"
                      name="map-marker-alt"
                    />{" "}
                    3550 Lenox Rd NE Suite 2100
                  </p>
                  <p className="question-form-text">
                    <FontAwesome className="phone" name="phone" />
                    404-474-4774
                  </p>
                  <p className="question-form-text">
                    <FontAwesome className="envelope" name="envelope" />{" "}
                    info@itslighthouse.com
                  </p>
                </Col>

                <Col className="white" sm={{ size: 7 }}>
                  <form
                    id="aboutUs"
                    action=""
                    method=""
                    onSubmit={this.submitDetails.bind(this)}
                  >
                    <input type="hidden" name="lead_source" value="Website" />
                    <input type="hidden" name="oid" value="00D3i000000GUvA" />
                    <input
                      type="hidden"
                      name="00N3i00000Bm5C9"
                      value="About_us_website_v1"
                      
                    />
                    <input
                      type="hidden"
                      name="retURL"
                      
                      value="https://www.atlighthouse.com/thank-you"
                    />

                    <Row>
                      <Col sm={{ size: 6 }}>
                        <label className="apply-now-labels" htmlFor="full_name">
                          Name<p className="required-symbol">{"*"}</p>
                        </label>
                        <input
                          id="first_name"
                          maxLength="60"
                          name="first_name"
                          className="input-form form-control"
                          size="20"
                          type="text"
                          ref="first_name"
                          placeholder="Full Name"
                        />

                        {this.state.errorsdiv === true ? (
                          <span className="error">
                            {this.state.errors["first_name"]}
                          </span>
                        ) : (
                          ""
                        )}

                        <br />
                      </Col>

                      <Col>
                        <label htmlFor="email" className="apply-now-labels">
                          Email<p className="required-symbol">{"*"}</p>
                        </label>
                        <input
                          id="email"
                          maxLength="80"
                          name="email"
                          size="20"
                          type="email"
                          className="apply-now-inputs form-control"
                          ref="email"
                          placeholder="Email"
                        />
                        {this.state.errorsdiv === true ? (
                          <span className="error">
                            {this.state.errors["email"]}
                          </span>
                        ) : (
                          ""
                        )}
                        <br />
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <label
                          className="apply-now-labels"
                          htmlFor="exampleSelect"
                        >
                          What course are you interested in?
                        </label>
                        <select
                          id="00N3i00000Bkld5"
                          name="00N3i00000Bkld5"
                          title="Which course are you applying for?"
                          className="apply-now-inputs form-control"
                        >
                          <option value=""></option>
                          <option value="Full Stack Web Development Immersive">
                            Software Engineering Immersive
                          </option>
                          <option value="Data science and Analytics Immersive">
                            Data science and Analytics Immersive
                          </option>
                          <option value="Digital Marketing Intensive">
                            Digital Marketing Intensive
                          </option>
                          <option value="Experience Design Intensive">
                            Experience Design Intensive
                          </option>
                          <option value="Full Stack Web Development Intensive">
                            Full Stack Web Development Intensive
                          </option>
                          <option value="Data Science &amp; Analytics Intensive">
                            Data Science &amp; Analytics Intensive
                          </option>
                        </select>
                        <br />
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <label
                          className="apply-now-labels"
                          htmlFor="exampleSelect"
                        >
                          When are you looking to take the course?
                        </label>
                        <select
                          id="00N3i00000Bkld5"
                          name="00N3i00000Bkld5"
                          title="Which course are you applying for?"
                          className="apply-now-inputs form-control"
                        >
                          <option value=""></option>
                          <option value="Immediate">Immediate</option>
                          <option value="One to three months">
                            One to three months
                          </option>
                          <option value="Three to six months">
                            Three to six months
                          </option>
                          <option value="Six months to one year">
                            Six months to one year
                          </option>
                          <option value="Not sure">Not sure</option>
                        </select>
                        <br />
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <label className="apply-now-labels" htmlFor="message">
                          Message
                        </label>
                        <textarea
                          id="00N3i00000Bklln"
                          name="00N3i00000Bklln"
                          rows="6"
                          type="text"
                          wrap="soft"
                          className="apply-now-inputs form-control"
                          placeholder="Ask your question here."
                        ></textarea>
                        <br />
                      </Col>
                    </Row>
                    <div>
                      <input
                        type="submit"
                        name="submit"
                        className="courses-button btn-secondary"
                      />
                    </div>
                  </form>
                  <p className="privacy-terms mt-0">
                    <i>
                      By providing your email, you agree to our{" "}
                      <u>
                        <Link style={{ color: "white" }} to="/privacy-policy">
                          privacy policy
                        </Link>
                      </u>{" "}
                      and{" "}
                      <u>
                        <Link style={{ color: "white" }} to="/terms-of-service">
                          terms of conditions
                        </Link>
                      </u>
                    </i>
                    .
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default QuestionForm;
